import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-common-id-sign-out-header',
  templateUrl: './sign-out-header.component.html',
  styleUrls: ['./sign-out-header.component.scss']
})
export class CommonIdSignOutHeaderComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
